import { jsx } from 'react/jsx-runtime';
import { t } from './i18n.es.js';
import { useState, useEffect } from 'react';
import { c as calculateTimeDelta } from './time-41e6541a.js';
import { styled, Caption, isMobile } from '@teko/ds-desktop';
import { getComponentSize } from './helpers.es.js';

const addPaddingNumber = (number) => number.toString().padStart(2, '0');
const SIZE = {
    s: {
        level: 3,
    },
    m: {
        level: 1,
    },
};
const CountdownTime = ({ endAt, }) => {
    const size = getComponentSize(isMobile);
    const [duration, setDuration] = useState(calculateTimeDelta(new Date(), endAt));
    useEffect(() => {
        const intervalId = setInterval(() => {
            if (duration.milliseconds !== 0) {
                setDuration(calculateTimeDelta(new Date(), endAt));
            }
        }, 1000);
        return () => {
            clearInterval(intervalId);
        };
    }, []);
    const displayCountdown = () => {
        if (duration.days !== 0) {
            return t('Còn {{DurationDays}} ngày', { DurationDays: duration.days });
        }
        return `${addPaddingNumber(duration.hours)}:${addPaddingNumber(duration.minutes)}:${addPaddingNumber(duration.seconds)}`;
    };
    return (jsx(Timer, Object.assign({ level: SIZE[size].level, weight: "bold", color: "white" }, { children: displayCountdown() }), void 0));
};
const Timer = styled(Caption) `
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
`;

export { CountdownTime as C };
